import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PrincipalComponent } from './principal/principal.component';
import { AppRouters } from './app.route';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { TooltipModule } from 'ng2-tooltip-directive';

//Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BannerComponent } from './banner/banner.component';

@NgModule({
  declarations: [
    AppComponent,
    PrincipalComponent,
    BannerComponent,
    NumberFormatPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule, 
    AppRouters,
    HttpClientModule,
    TooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http);
        },
        deps: [ HttpClient ]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
